import { documentsApi } from 'api';
import { DOCUMENTS_MANAGEMENT_API_APPENDIX } from 'constants/baseUrl';
import { MetadataSearchItem } from '#web-components/components/Form/types';

export const getMetadataByIds = (searchMap: MetadataSearchItem[], rootProcessInstanceId: string, taskId: string) => {
  return documentsApi.post$(`${DOCUMENTS_MANAGEMENT_API_APPENDIX}/${rootProcessInstanceId}/${taskId}/search`, {
    documents: searchMap,
  });
};
